module.exports = __webpack_public_path__ + "img/employee-2-old.87a2e074.jpg";